import { PRODUCT_SLUGS } from '@discover-frontend/constants';
import { getProductSlug } from '@discover-frontend/utils';

export const selectFilteredUserProducts = (data) => {
  return data.filter(
    (product) =>
      product.slug !== getProductSlug() &&
      product.slug !== PRODUCT_SLUGS.HX_ENGINE_UI
  );
};
